import { Link } from '@tanstack/react-router';
import { Ticket } from 'lucide-react';
import { cn } from '@/lib/cn';
import { countryName } from '@/i18n';
import { formatDate } from '@/lib/format';
import { useVignettes } from '@/api/hooks/vignettes';

/**
 * Винетките на един бус — ред чипове на страницата му. Подновяването е в
 * „Винетки", тук само се вижда дали бусът може да мине през държавата.
 */
export function VanVignettes({ vehicleId, className }: { vehicleId: string; className?: string }) {
  const matrix = useVignettes();
  const van = matrix.data?.vehicles.find((v) => v.id === vehicleId);
  if (!matrix.data || !van) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5 text-xs', className)}>
      <Link to="/vignettes" className="mr-1 inline-flex items-center gap-1 font-medium text-ink-dim hover:text-accent">
        <Ticket className="size-3.5" />
        Винетки
      </Link>
      {matrix.data.countries.map((country) => {
        const v = van.cells[country] ?? null;
        return (
          <span
            key={country}
            className={cn(
              'rounded-full border px-2 py-0.5',
              !v || v.status === 'expired'
                ? 'border-danger/40 bg-danger-soft/40 text-danger'
                : v.status === 'expiring'
                  ? 'border-warn/40 bg-warn-soft/40 text-warn'
                  : 'border-ok/30 bg-ok-soft/30 text-ink',
            )}
          >
            {countryName(country)}: {!v ? 'няма' : v.status === 'expired' ? `изтекла ${formatDate(v.validUntil)}` : `до ${formatDate(v.validUntil)}`}
          </span>
        );
      })}
    </div>
  );
}
